<template>
  <q-input
    v-model="model"
    :placeholder="placeholder"
    :disabled="disabled"
    :min="0"
    :max="100"
  >
    <template slot="append">
      <font-awesome-icon :icon="['fas', 'percentage']" />
    </template>
  </q-input>
</template>
<script>

  import inputMixin from "./inputMixin";

  export default {
    name: 'QPercentage',
    mixins:[inputMixin],
  };
</script>
